import React from 'react'
import moment from 'moment'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'
import { DMY_CASUAL_FORMAT } from 'constants/dateFormats'
import Group from 'components/utils/Group'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import { connect } from 'react-redux'
interface MappedProps {
  canViewLuxPlusBenefits: boolean;
}
interface Props extends MappedProps{
  bookByDate: string;
  travelByDate: string;
}

function BnblPackageDatesGift(props: Props) {
  const { bookByDate, travelByDate, canViewLuxPlusBenefits } = props

  return (
    <Group direction="vertical" gap={8} tabletGap={16}>
      <BodyText variant="medium">Purchasing this as a gift will secure the offer for your recipient and give them the flexibility to choose travel dates at a later time. Dates must be within the book by and validity period and are subject to availability and surcharges.</BodyText>
      <BodyText variant="medium">Your recipient can manage and make changes to their booking according to our 7-day ‘change of mind’ guarantee after booking.</BodyText>
      <Group direction="vertical" gap={8}>
        <BodyText variant="medium">
          Your recipient must book their dates by&nbsp;<BodyText as="span" weight="bold" variant="medium"> {moment(bookByDate).format(DMY_CASUAL_FORMAT)}</BodyText>&nbsp;
          and travel by&nbsp;<BodyText as="span" weight="bold" variant="medium">{moment(travelByDate).format(DMY_CASUAL_FORMAT)}</BodyText>.*
        </BodyText>
        <Caption colour="neutral-three" variant="medium">*Subject to availability, and additional charges including seasonal, weekend, peak period, and property-specific surcharges.</Caption>
        {canViewLuxPlusBenefits && <Caption colour="neutral-three" variant="medium">*Member pricing does not apply when giving a  package as a gift.</Caption>}
      </Group>
    </Group>
  )
}

function mapStateToProps(state: App.State): MappedProps {
  return {
    canViewLuxPlusBenefits: getCanViewLuxPlusBenefits(state),
  }
}

export default connect(mapStateToProps)(BnblPackageDatesGift)
